import React, { useEffect, useState } from "react";
import { FaTrash } from "react-icons/fa";
import { useParams } from "react-router-dom";
import { FaCirclePlus } from "react-icons/fa6";
import { useDeleteChildAccountByIdMutation, useGetAllChildAccountQuery, useGetChildAccountByIdQuery } from "../childAccountApi";
import ModalButton from "../../../../components/common/form/ModalButton";
import ChildAccountFields from "../modal/ChildAccountField";
import ConfirmationModal from "../../../../components/layout/modal/ConfirmationModal";
import { skipToken } from "@reduxjs/toolkit/query";
import { hasPermission } from "../../../../helpers/utils/AccessControlUtils";

const SubdivisionChildAccount = () => {

    let { subdivisionId } = useParams();
    const [childData, setChildData] = useState<any>({});

    const { data: childAccountData } = useGetAllChildAccountQuery(subdivisionId);
    const [deleteApi, { isLoading }] = useDeleteChildAccountByIdMutation();
    const [selectedContact, setSelectedContact] = useState(null);
    const [childId, setChildId] = useState();
    const [show, setShow] = useState(false);
    const childAccountByIdData = useGetChildAccountByIdQuery(childId ?? skipToken);

    useEffect(() => {
        let obj = childAccountData;
        if (obj) {
            setChildData({
                ...obj,
            });
        }
    }, [childAccountData]);

    const handleDelete = (id: any) => {
        deleteApi(id);
    }
    const handleRowClick = (childId: any) => {
        setSelectedContact(childId);
        setChildId(childId)
        setShow(true);
    };

    return (
        <div className="bg-text-1 shadow-[0_3px_10px_#0003] text-sm mt-3 rounded-md ">
            <div className="flex justify-between items-center  border-b border-[rgba(0,0,0,0.1)] p-2">
                <h5 className="font-semibold text-surface-0">Child Accounts ({childAccountData?.length || 0})</h5>
                {hasPermission(["SUBD-U"]) &&
                    <ModalButton triggerButton={<FaCirclePlus className={"text-highlight-0"}/>}
                        modal={
                            <ChildAccountFields show={true} setShow={() => {
                            }} title={"Add Child Account"} formType={"Add"} />
                        }
                    />}

            </div>
            <div className="p-2 max-h-[150px] overflow-auto scrollbar-hide">
                <table className="w-full bg-text-0 border-b border-[rgba(0,0,0,0.1)] border">
                    <thead className="border-b-2 border-[rgba(0,0,0,0.1)]">
                        <tr>
                            {["Block", "Lot", "Account No.", "Geo ID", ...(hasPermission(["SUBD-U"]) ? ["Action"] : [])].map((heading) => (
                                <th key={heading} className="text-left whitespace-nowrap">{heading}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {childAccountData?.length === 0 ? (
                            <tr>
                                <td colSpan={13} className="p-2">
                                    No data available
                                </td>
                            </tr>
                        ) : (
                            childAccountData?.map((data: any) => (
                                <tr key={data.id} className="bg-text-1">
                                    <td
                                        className="p-2 text-highlight-4 cursor-pointer"
                                        onClick={() => handleRowClick(data.id)}
                                    >
                                        {data?.block}
                                    </td>
                                    <td className="p-2">{data.lot || "-"}</td>
                                    <td className="p-2">{data.accountNumber || "-"}</td>
                                    <td className="p-2">{data.geoId || "-"}</td>
                                    <td className="p-2 text-red-600 cursor-pointer">
                                        {hasPermission(["SUBD-U"]) &&
                                            <ModalButton
                                                triggerButton={<FaTrash className="text-highlight-0" />}
                                                modal={
                                                    <ConfirmationModal
                                                        show={true}
                                                        setShow={() => { }}
                                                        title={"Delete Child Account"}
                                                        bodyMessage={"Are you sure you want to delete this Child Account?"}
                                                        onSubmit={() => handleDelete(data.id)}
                                                        isLoading={isLoading}
                                                    />
                                                }
                                            />
                                        }

                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>

                </table>

            </div>
            {show && (
                <ChildAccountFields show={true} setShow={setShow} title={"Update Child Account"} formType={"Update"} childId={childId}
                    childAccountData={childAccountByIdData} />
            )}
        </div>

    );
};

export default SubdivisionChildAccount;
